import type { Person } from '../../../eventsApi/persons/person'
import type { ProductMovement } from '../product-movements/product-movement'

export class ProductInvoice {
    productInvoiceId: string
    personId?: string
    companyId: string
    createdAt: Date
    updatedAt: Date
    acquiredAt?: Date
    status: number
    invoiceNumber?: string
    notes?: string
    productMovement?: ProductMovement[]
    person?: Person
}
